import { connect } from 'react-redux'
import { GameHome } from '../components'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  return ({
    width
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GameHome)


// WEBPACK FOOTER //
// ./src/Pages/Game/containers/GameHome.js